import React, { useRef } from "react";
import { Camera } from "lucide-react";

import styles from "./PracticeLogoUpload.module.css";

/**
 * The practice logo. The file input stays hidden and is opened by the visible
 * button, so the whole control is one keyboard-reachable target.
 */
export const PracticeLogoUpload = ({ imageSource, onFileSelected }) => {
  const fileInputRef = useRef(null);

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleChange = (event) => {
    onFileSelected(event.target.files[0]);
  };

  return (
    <div className={styles.logoUpload}>
      <button
        type="button"
        className={styles.logoButton}
        onClick={openFilePicker}
        aria-label="Upload practice logo"
        data-testid="practice-logo-upload"
      >
        {imageSource ? (
          <img className={styles.logo} src={imageSource} alt="Practice logo" />
        ) : (
          <span className={styles.logoPlaceholder} aria-hidden />
        )}

        <span className={styles.cameraBadge} aria-hidden>
          <Camera size={16} />
        </span>
      </button>

      <input
        type="file"
        ref={fileInputRef}
        className={styles.hiddenFileInput}
        accept="image/*"
        onChange={handleChange}
      />
    </div>
  );
};
